import { CohesionSnippetConfig } from '@redventures/cohesion-utils-react/dist/CohesionSnippet';

const production = process.env.environment === 'production';

export const cohesionSnippet: CohesionSnippetConfig = {
  tagular: {
    writeKey: production ? 'wk_2AX594nD4VrsxQ6I95nBaOGHRMd' : 'wk_29z6TBCrjeQDEeC9BnOnrtM1WZw',
    sourceKey: production ? 'src_2AX595R5Gm95HmJWVMaiMTn1AGp' : 'src_29z6T8TdydFfdWuCkLa7Gx9m80V',
    apiKey: '2646f3b4-2a12-48ac-979d-ad332d8e53a6.be7259f3-a108-4532-b2d6-cabba9185e07',
    apiHost: 'https://business.frontier.com/rv-assets/beam',
    cookieDomain: production ? 'frontier.com' : '',
    taggy: { enabled: true }
  },
  consent: { required: false },
  monarch: {
    sourceId: '203e9505-3a67-4b30-9b0b-6cf049a4591c',
    token: '7f339099-a47f-496c-96aa-b6f5b79bb8b3',
    autoRequest: {
      enabled: true,
      suppressPlacements: false
    }
  },
  fuse: {
    enabled: false
  }
};
